import React from 'react';
import { Button, Card, Space, Typography } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import VendorList from '@/components/vendor/VendorList';

const { Title, Text } = Typography;

const VendorsPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div style={{ padding: '24px' }}>
      <div style={{ marginBottom: '24px' }}>
        <Space style={{ width: '100%', justifyContent: 'space-between' }} align="start">
          <div>
            <Title level={2} style={{ marginBottom: 0 }}>Vendors</Title>
            <Text type="secondary">Admin vendor directory</Text>
          </div>
          <Button type="primary" icon={<PlusOutlined />} onClick={() => navigate('/vendors/new')}>
            Create Vendor
          </Button>
        </Space>
      </div>
      <Card>
        <VendorList />
      </Card>
    </div>
  );
};

export default VendorsPage;
